import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BusinessApiService {
  private base = `${environment.apiUrl}`;

  constructor(private http: HttpClient) {}

  getUsers(params?: any) {
    return this.http.get<any>(`${this.base}/users`, { params });
  }

  getUser(id: string) {
    return this.http.get<any>(`${this.base}/users/${id}`);
  }

  createUser(data: any) {
    return this.http.post(`${this.base}/bachloria`, data);
  }

  updateUser(id: string, data: any) {
    return this.http.put(`${this.base}/users/${id}`, data);
  }

  deleteUser(id: string) {
    return this.http.delete(`${this.base}/users/${id}`);
  }
}